import script from "./ModalAddJugadorTorneoMas.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalAddJugadorTorneoMas.vue?vue&type=script&setup=true&lang=ts"

import "./ModalAddJugadorTorneoMas.vue?vue&type=style&index=0&id=46a0055d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a0055d"]])

export default __exports__